import { toast } from "sonner";
import { api } from "@/lib/api";

export const downloadBlob = async (url, filename, params) => {
  try {
    const res = await api.get(url, { params, responseType: "blob" });
    const href = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = href; a.download = filename; a.click();
    URL.revokeObjectURL(href);
    return true;
  } catch {
    toast.error("Download failed");
    return false;
  }
};
